export const formatProfilePicLink = (photoKey: string, user_id: number) =>
  `${process.env.REACT_APP_S3_URL}/${process.env.REACT_APP_S3_BUCKET_PUBLIC_ASSETS}/${user_id}/${photoKey}`
